var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center text-lg font-bold"},[_vm._v(" "+_vm._s(_vm.selectedOtherMenusInfo.virtual_space.title)+" ")]),_c('div',{staticClass:"my-4"},[_c('router-view',{on:{"closeDialog":function($event){return _vm.$emit('closeDialog')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }